import * as types from './types';

export const importsMutations = {
  [types.ImportsList.SET.ALL](state, payload) {
    state.importsList = payload;
  },
  [types.ImportsList.DELETE.SINGLE](state, payload) {
    let list = state.importsList?.statement_settings;
    list = list.map(l => {
      l.statements = l.statements.filter(s => s.statement_id !== payload.statement_id)
      return l
    })
    state.importsList = {
      ...state.importsList,
      statement_settings: [
        ...list
      ]
    }
  },
  [types.BasicFilter.SET.SINGLE](state, payload) {
    state.basicFilter = {...payload};
  },

}